import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {T} from 'react-polyglot-hooks';
import getRoomPartiesOverMaxOccupancy from './getRoomPartiesOverMaxOccupancy.api';
import useRouter from 'use-react-router';
import {RoomParty} from '../../../graphql/groups.datatypes';

const useStyles = makeStyles(() => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const RoomPartyMaxOccupancy = (props: { className?: string }) => {
  const {className, ...rest} = props;
  const classes = useStyles();
  const {history} = useRouter();
  const roomPartiesData = getRoomPartiesOverMaxOccupancy();

  const getPrimaryOccupantName = (roomParty: RoomParty) => {
    return roomParty.members!.filter(member => member.primary_occupant).map(member => member.groupMember!.first_name.substr(0, 1) + ' ' + member.groupMember!.last_name);
  };

  return (
      <Card
          {...rest}
          className={clsx(classes.root, className)}
      >
        <CardHeader title="Room Parties with no Room Resource"/>
        <Divider/>
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              {roomPartiesData.loading && (
                  <Typography><T phrase="Loading..."/></Typography>
              )}
              {!roomPartiesData.loading &&
              roomPartiesData.data &&
              roomPartiesData.data.roomPartiesOverMaxOccupancy && (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{width: 100}}>Id</TableCell>
                        <TableCell>Group</TableCell>
                        <TableCell>Primary Occupant</TableCell>
                        <TableCell style={{width: 190}}>Date Booked</TableCell>
                        <TableCell style={{width: 100}}># Occupants</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {roomPartiesData.data.roomPartiesOverMaxOccupancy.map(party => {
                        return (
                            <TableRow
                                hover
                                key={party.id}
                                onClick={() => history.push('/room_party/' + party.id)}
                            >
                              <TableCell>{party.id}</TableCell>
                              <TableCell>{party.booking && party.booking.group && party.booking.group.name}</TableCell>
                              <TableCell>{getPrimaryOccupantName(party)}</TableCell>
                              <TableCell>{party.booking && party.booking.created_at}</TableCell>
                              <TableCell>{party.members && party.members.length}</TableCell>
                            </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
              )}
            </div>
          </PerfectScrollbar>

        </CardContent>
      </Card>
  );
};

export default RoomPartyMaxOccupancy;
